/* eslint-disable semi,semi-style */
/**
 * 获取当前环境
 */
// const { NODE_ENV } = 
const { hostname } = location

let envir
let prefix

if (process.env.NODE_ENV === 'development') {
  envir = 'dev'
  prefix = 'https://gw-test.intra.xiaojukeji.com'
} else if (/open-epower\.intra\.xiaojukeji\.com/.test(hostname)) {
  envir = 'test'
  prefix = 'https://gw-test.intra.xiaojukeji.com'
} else if (/open-epower-pre\.intra\.xiaojukeji\.com/.test(hostname) || /static-pre\.am\.xiaojukeji\.com/.test(hostname)) {
  envir = 'pre'
  prefix = 'https://gw-pre.am.xiaojukeji.com'
} else if (/open-epower\.xiaojukeji\.com/.test(hostname)) {
  envir = 'online'
  prefix = 'https://gw.am.xiaojukeji.com'
}

export const env = envir
export const host = prefix

export const urls = {
  dev: 'https://unicorn-test.intra.xiaojukeji.com/dashboard',
  test: 'https://unicorn-test.intra.xiaojukeji.com/dashboard',
  pre: 'https://unicorn-pre.intra.xiaojukeji.com/dashboard',
  online: 'https://unicorn.xiaojukeji.com/dashboard',
};
